import type { ISerialize } from '@/objects/ISerialize';

export class ManagerUser implements ISerialize {
    public ID: number;

    public Email: string | null;

    public FederationID: number | null;

    public GoogleAvatar: string | null;

    public HasRegion: boolean;

    public IsFederation: boolean;

    public IsSuperAdmin: boolean;

    public Name: string;

    public RegionIDs: number[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        ID?: number;
        Email?: string | null;
        FederationID?: number | null;
        GoogleAvatar?: string | null;
        HasRegion?: boolean;
        IsFederation?: boolean;
        IsSuperAdmin?: boolean;
        Name?: string | null;
        RegionIDs?: number[];
    }) {
        this.ID = values.ID ?? 0;

        this.Email = values.Email ?? null;

        this.FederationID = values.FederationID ?? null;

        this.GoogleAvatar = values.GoogleAvatar ?? '';

        this.HasRegion = values.HasRegion ?? false;

        this.IsFederation = values.IsFederation ?? false;

        this.IsSuperAdmin = values.IsSuperAdmin ?? false;

        this.Name = values.Name ?? '';

        this.RegionIDs = values.RegionIDs ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"ID": ${JSON.stringify(this.ID)}` +
            ',' +
            `"Email": ${JSON.stringify(this.Email)}` +
            ',' +
            `"FederationID": ${JSON.stringify(this.FederationID)}` +
            ',' +
            `"GoogleAvatar": ${JSON.stringify(this.GoogleAvatar)}` +
            ',' +
            `"HasRegion": ${JSON.stringify(this.HasRegion)}` +
            ',' +
            `"IsFederation": ${JSON.stringify(this.IsFederation)}` +
            ',' +
            `"IsSuperAdmin": ${JSON.stringify(this.IsSuperAdmin)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"RegionIDs": [ ${this.RegionIDs.map((x) => JSON.stringify(x))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of ManagerUser from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        ID?: number;
        Email?: string | null;
        FederationID?: number | null;
        GoogleAvatar?: string | null;
        HasRegion?: boolean;
        IsFederation?: boolean;
        IsSuperAdmin?: boolean;
        Name?: string | null;
        RegionIDs?: number[];
    }): ManagerUser {
        return new ManagerUser(values);
    }

    public static _FromServerJson(json: any): ManagerUser {
        return new ManagerUser({
            ID: json.ID,
            Email: json.Email ?? '',
            FederationID: json.FederationID ?? null,
            GoogleAvatar: json.GoogleAvatar ?? '',
            HasRegion: json.HasRegion,
            IsFederation: json.IsFederation,
            IsSuperAdmin: json.IsSuperAdmin,
            Name: json.Name ?? '',
            RegionIDs: json.RegionIDs,
        });
    }

    /**
     * Creates an instance of ManagerUser from another instance of ManagerUser.
     * @param other The ManagerUser you want to clone
     * @returns A cloned ManagerUser
     */
    public static FromOther(other: ManagerUser): ManagerUser {
        return ManagerUser._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ManagerUser.FromOther(this);
    }

    static NAME_OF_CLASS = 'ManagerUser';
}
